var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crm-container"},[_vm._t("default"),(_vm.helpSideShow)?_c('HelpSide',{attrs:{"props":_vm.helpSideProps},on:{"close":function($event){_vm.helpSideShow = false}}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }